module.exports = __webpack_public_path__ + "124ee1cae915fadf2d4f0a209f3410bb.png";